import { Component, OnDestroy, OnInit } from "@angular/core";
import { SettingsField, SettingsToSaveType } from "./settings-to-save.type";
import { TemplateSettingsService } from "./template-settings.service";
import { Observable } from "rxjs/index";
import { User } from "../core/model/user.model";
import { UserSelectors } from "../user/state/user.selectors";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { BsModalService } from "ngx-bootstrap/modal";
import {
  BsModalAlertComponent,
  createAlertModalOptions,
} from "../core/modal/modal-alert.component";

@Component({
  selector: "template-settings-component",
  templateUrl: "template-settings.component.html",
  styles: [
    `
      .width-50 {
        width: 50%;
      }
      .text-centered {
        text-align: center;
      }
      div.no-padding-left {
        padding-left: 0;
        padding-right: 0;
      }
    `,
  ],
})
export class TemplateSettingsComponent implements OnInit, OnDestroy {
  labelAndValues: { key: string; label: string }[] = [];
  viewModelSettings: SettingsToSaveType;
  settingToDisplay: SettingsToSaveType;
  selectedUser$: Observable<User>;
  loading$: Observable<boolean>;
  _subscription: Subscription;

  constructor(
    private templateSettingsService: TemplateSettingsService,
    private userSelector: UserSelectors,
    private bsModalService: BsModalService
  ) {
    this._subscription = new Subscription();
    this.selectedUser$ = this.userSelector.selectSelectedUser();
    this.loading$ = this.userSelector.selectUsersSearchLoading();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  ngOnInit() {
    this.labelAndValues = [
      { key: "websiteLabel", label: "Web site" },
      { key: "website", label: "Web site url" },
      { key: "map", label: "Map" },
      { key: "facebook", label: "Facebook" },
      { key: "yelp", label: "Yelp" },
      { key: "instagram", label: "Instagram" },
      { key: "linkedin", label: "LinkedIn" },
      { key: "twitter", label: "Twitter" },
    ];
    this._subscription.add(
      this.selectedUser$
        .pipe(filter((user) => Boolean(user)))
        .subscribe((user) => {
          this.initializeSettings(user);
        })
    );
  }

  initializeSettings(user: User): void {
    this.labelAndValues.forEach((item) => {
      if (Boolean(user.userCustomFields[item.key])) {
        this.viewModelSettings = {
          ...this.viewModelSettings,
          [item.key]: this.removeHttpsString(user.userCustomFields[item.key]),
        };
      } else {
        this.viewModelSettings = {
          ...this.viewModelSettings,
          [item.key]: "",
        };
      }
    });
  }

  onSave(userId: number): void {
    const settingsToSave = this.getSettingWithHttps(this.viewModelSettings);
    this._subscription.add(
      this.templateSettingsService
        .saveCommunicationSettings(userId, settingsToSave)
        .subscribe(
          () => {
            this.bsModalService.show(
              BsModalAlertComponent,
              createAlertModalOptions(
                "Setting saved",
                "Template settings has been saved successfully!"
              )
            );
          },
          (error) =>
            this.bsModalService.show(
              BsModalAlertComponent,
              createAlertModalOptions("Error on save", error.toString())
            )
        )
    );
  }

  private removeHttpsString(value: string): string {
    return value.replace(/https:\/\//g, "");
  }

  private addHttpsString(value: string): string {
    const auxValue = this.removeHttpsString(value);
    return `https://${auxValue}`;
  }

  private getSettingWithHttps(
    settings: SettingsToSaveType
  ): SettingsToSaveType {
    return Object.keys(settings).reduce((previousValue, key) => {
      if (settings[key] === "") {
        return previousValue;
      }

      if (key === "websiteLabel") {
        return {
          ...previousValue,
          [key]: settings[key],
        };
      }

      return {
        ...previousValue,
        [key]: this.addHttpsString(settings[key]),
      };
    }, {});
  }
}
